import { EventLanguage } from "../../../../utils/Languages";
import { dateFormatter } from "../../../../utils/Helper";

const TicketTypeList = (props) => {
  const TicketTypeTableColumn = EventLanguage.TicketTypeTableColumn;

  const getSaleRange = (ticket) => {
    if (
      new Date() <= new Date(ticket.salesEnd) &&
      new Date() >= new Date(ticket.salesStart)
    ) {
      return "On sale";
    }
    if (new Date() > new Date(ticket.salesEnd)) {
      return "Sale has been Ended";
    }
    return `Sale will start on ${dateFormatter(
      ticket.salesStart
    )} & End on ${dateFormatter(ticket.salesEnd)}`;
  };

  return (
    <div className="event-tickets-list">
      <div className="event-tickets-table-wrap">
        <table className="event-tickets-table" aria-label="Created tickets">
          <thead>
            <tr>
              <th scope="col">{TicketTypeTableColumn.sNo}</th>
              <th scope="col">{TicketTypeTableColumn.Ticket}</th>
              <th scope="col">{TicketTypeTableColumn.Price}</th>
              <th scope="col">{TicketTypeTableColumn.QTY}</th>
              <th scope="col">{TicketTypeTableColumn.Action}</th>
            </tr>
          </thead>
          <tbody>
            {props.event.status &&
              props.event.data.ticketType?.map((ticket, index) => {
                const canModify = ticket.quantity === ticket.total_qty;

                return (
                  <tr key={ticket._id || index}>
                    <td data-label={TicketTypeTableColumn.sNo}>{index + 1}</td>
                    <td data-label={TicketTypeTableColumn.Ticket}>
                      <div className="event-tickets-name">{ticket.name}</div>
                      <div className="event-tickets-sale-range">
                        {getSaleRange(ticket)}
                      </div>
                    </td>
                    <td data-label={TicketTypeTableColumn.Price}>
                      USD {ticket.price}
                    </td>
                    <td data-label={TicketTypeTableColumn.QTY}>
                      {ticket.quantity}
                    </td>
                    <td data-label={TicketTypeTableColumn.Action}>
                      {canModify ? (
                        <div className="event-tickets-actions">
                          <button
                            type="button"
                            className="event-tickets-edit-btn"
                            disabled={props?.isLoading}
                            onClick={() => props.ShowForm(ticket)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="event-tickets-delete-btn"
                            disabled={props?.isLoading}
                            onClick={() => props.deleteTicket(ticket)}
                          >
                            Delete
                          </button>
                        </div>
                      ) : (
                        <span className="event-tickets-locked-note">
                          This ticket can not be edited or deleted
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TicketTypeList;
